import React from "react";
import styles from "./content-footer.scss";

export default function ContentFooter(props) {
    return (
        <div className={styles.wrapper}>
            <span>{props.children}</span>
        </div>
    )
};